"use client";

import { Portal } from "@radix-ui/react-portal";
import { ComponentProps, memo, useEffect, useState } from "react";

import { renderEmbedContent } from "./RenderEmbedClientSide.js";

const CustomPortal = memo(
  ({
    content,
    getVideoAspect,
    ...props
  }: ComponentProps<typeof Portal> & { getVideoAspect }) => {
    useEffect(() => {}, []);
    return (
      <Portal {...props}>{renderEmbedContent(content, getVideoAspect)}</Portal>
    );
  }
);

export function EmbedContentSideRenderer({ body, getVideoAspect }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  return (
    <>
      {body.content
        .filter(
          (content) =>
            typeof content?.attrs?.["data-id"] === "number" ||
            typeof content?.attrs?.["data-id"] === "string"
        )
        .filter((content) => content?.attrs?.side)
        .map((content) => {
          return (
            <CustomPortal
              key={`embed-content-side-${content.attrs["data-id"]}-${content.attrs.key}`}
              container={document?.querySelector(
                `[data-id='${content.attrs["data-id"]}']`
              )}
              content={content}
              getVideoAspect={getVideoAspect}
            />
          );
        })}
    </>
  );
}
